class CartDrawerOffer extends HTMLElement {
  constructor() {
    super();
    this.idPrefix = this.dataset.idPrefix;
    this.manualForms = this.querySelectorAll(`[id^="Cart-Drawer-${this.idPrefix}-Form-Manual-"]`);
    this.automaticForm = this.querySelector(`form#Cart-Drawer-${this.idPrefix}-Form-Automatic`);
    this.removeGiftsForm = this.querySelector(`form#Cart-Drawer-${this.idPrefix}-Remove`);
    this.removeOldGiftsForm = this.querySelector(`form#Cart-Drawer-${this.idPrefix}-Remove-Old`);
    this.offerTitle = this.querySelector('[data-title-manual]')
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.checkoutSubmitButton = this.cart ? this.cart.querySelector('[name="checkout"]') : undefined;
    this.cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');

    this.settings = JSON.parse(this.querySelector(`script[type="application/json"]#${this.idPrefix}-data`).innerHTML);
    this.cart = JSON.parse(this.querySelector(`script[type="application/json"]#${this.idPrefix}-Cart-data`).innerHTML);
  }

  connectedCallback() {
    this.onInputChange = this.onInputChange.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.manualForms.forEach((manualForm) => {
      manualForm.addEventListener('submit', this.onFormSubmit);
    });
    this.addEventListener('change', this.onInputChange);
    this.automaticForm.addEventListener('submit', this.onFormSubmit);
    this.removeOldGiftsForm.addEventListener('submit', this.onFormSubmit);
    this.removeGiftsForm.addEventListener('submit', this.onFormSubmit);

    // console.log('remove gift form', this.removeGiftsForm);

    this.init();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onInputChange);
    this.manualForms.forEach((manualForm) => {
      manualForm.removeEventListener('submit', this.onFormSubmit);
    });
    this.automaticForm.removeEventListener('submit', this.onFormSubmit);
    this.removeOldGiftsForm.removeEventListener('submit', this.onFormSubmit);
    this.removeGiftsForm.removeEventListener('submit', this.onFormSubmit);
  }

  /**
   * 0. Check if there is old gifts not available anymore in the offer, if there is, then remove them from the cart by submitting the remove old gifts form
   * 1. Check if the offer is enabled, if it is, then check if the conditions are met
   * 2. If the conditions are met, then check if the offer is automatic or manual. If the conditions are not met, then remove the gifts from the cart
   * 3. If the offer is automatic, then add the gifts to the cart by submitting the automatic form
   * 4. If the offer is manual, then show the manual form
   */
  init() {
    this.removeOldGiftsForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    const conditionsMet = this.conditionsMet();
    if (this.settings.enable && conditionsMet) {
      if (this.settings.isAutomatic) {
        this.automaticForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      } else {
        this.offerTitle.classList.remove('hidden');
        this.manualForms.forEach((manualForm) => {
          manualForm.classList.remove('hidden');
        });
      }
    } else if (this.settings.enable && !conditionsMet) {
      this.removeGiftsForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  conditionsMet() {
    if (this.settings.offerType === 'products_in_cart' && this.settings.offerCondition.length > 0) {
      let conditionRespected = null;
      if (this.settings.allProductsShouldBeInCart) {
        conditionRespected = true;
        this.settings.offerCondition.forEach((stringId) => {
          if (!this.cart.items.find((item) => {
            return item.variant_id === parseInt(stringId, 10)
          })) {
            conditionRespected = false;
          }
        });
      } else {
        conditionRespected = false;
        this.settings.offerCondition.forEach((stringId) => {
          if (this.cart.items.find((item) => item.variant_id === parseInt(stringId, 10))) {
            conditionRespected = true;
          }
        });
      }

      return conditionRespected;
    }

    if (this.settings.offerType === 'minimal_purchase' && this.settings.offerCondition >= 0) {
      const rate = parseFloat(Shopify.currency.rate);
      return this.cart.total_price >= (this.settings.offerCondition * 100 * rate);
    }

    return false;
  }

  onFormSubmit(event) {
    // console.log('form submit', event.currentTarget);
    event.preventDefault();
    if (event.currentTarget.querySelectorAll('input').length === 0) return;
    this.enableLoading();
    const formData = new FormData(event.currentTarget);
    if (formData.has('id')) {
      this.cartItems.addLineItems(formData);
      return;
    }
    this.cartItems.updateQuantities(null, null, formData);

    return false;
  }

  enableLoading() {
    this.checkoutSubmitButton.setAttribute('aria-disabled', true);
    this.checkoutSubmitButton.classList.add('loading');
    this.checkoutSubmitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  }

  /**
   * When input changes, submit the form and disable all the inputs
   * @param {Event} event 
   */
  onInputChange(event) {
    const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
    const form = event.target.closest('form');
    form.dispatchEvent(submitEvent);
    this.disableInputs(form);
  }

  disableInputs(form) {
    const inputs = form.querySelectorAll('input');
    inputs.forEach((input) => input.setAttribute('disabled', true));
  }
}

customElements.define('cart-drawer-offer', CartDrawerOffer);